import { useEffect, useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import OptimizedImage from '../components/OptimizedImage';
import './room-carousel.css';

function RoomCarousel({ photos, roomName, onSelect }) {
  const [active, setActive] = useState(0);
  const current = photos[active % photos.length];

  useEffect(() => {
    setActive(0);
  }, [photos]);

  useEffect(() => {
    if (photos.length < 2) return undefined;
    const timer = window.setInterval(() => {
      setActive((index) => (index + 1) % photos.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, [photos]);

  const move = (step) => setActive((index) => (index + step + photos.length) % photos.length);

  return (
    <div className="room-carousel" aria-label={`${roomName} room media`}>
      <div className="room-carousel__frame" key={current.id || current.url}>
        {current.media_type === 'video' ? (
          <video src={current.url} controls playsInline preload="metadata" aria-label={current.caption || `${roomName} room video`} />
        ) : (
          <button type="button" onClick={() => onSelect(current)} aria-label={`View ${current.caption || roomName}`}>
            <OptimizedImage src={current.url} alt={current.caption || roomName} sizes="(max-width: 600px) 88vw, 88vw" width={1600} height={900} />
          </button>
        )}
      </div>
      {photos.length > 1 && (
        <>
          <button className="room-carousel__arrow room-carousel__arrow--previous" type="button" onClick={() => move(-1)} aria-label="Previous room photo"><SafeIcon name="ArrowLeft" /></button>
          <button className="room-carousel__arrow room-carousel__arrow--next" type="button" onClick={() => move(1)} aria-label="Next room photo"><SafeIcon name="ArrowRight" /></button>
          <div className="room-carousel__position">{String(active + 1).padStart(2, '0')} / {String(photos.length).padStart(2, '0')}</div>
        </>
      )}
    </div>
  );
}

export default RoomCarousel;